import { gql } from "generated/gql"

export const CREATE_SCHEDULED_EXPORT_MUTATION = gql(`
  mutation CreateScheduledExport(
    $dayOfMonth: Int
    $dayOfWeek: String
    $filename: String!
    $frequency: String!
    $recipients: [String!]!
    $savedReportId: ID!
    $timeOfDay: ISO8601DateTime!
    $weekCount: Int
    $distributionListIds: [ID!]
  ) {
    mutationResult:createScheduledExport (input: {
      dayOfMonth: $dayOfMonth
      dayOfWeek: $dayOfWeek
      filename: $filename
      frequency: $frequency
      recipients: $recipients
      savedReportId: $savedReportId
      timeOfDay: $timeOfDay
      weekCount: $weekCount
      distributionListIds: $distributionListIds
    }) {
      id
      errors
      scheduledExport {
        ...ScheduledExportFields
      }
    }
  }
`)

export const UPDATE_SCHEDULED_EXPORT_MUTATION = gql(`
  mutation UpdateScheduledExport(
    $id: ID!
    $dayOfMonth: Int
    $dayOfWeek: String
    $filename: String!
    $frequency: String!
    $recipients: [String!]!
    $savedReportId: ID!
    $timeOfDay: ISO8601DateTime!
    $weekCount: Int
    $distributionListIds: [ID!]
  ) {
    mutationResult:updateScheduledExport (input: {
      id: $id
      dayOfMonth: $dayOfMonth
      dayOfWeek: $dayOfWeek
      filename: $filename
      frequency: $frequency
      recipients: $recipients
      savedReportId: $savedReportId
      timeOfDay: $timeOfDay
      weekCount: $weekCount
      distributionListIds: $distributionListIds
    }) {
      id
      errors
      scheduledExport {
        ...ScheduledExportFields
      }
    }
  }
`)

export const DESTROY_SCHEDULED_EXPORT_MUTATION = gql(`
  mutation DestroyScheduledExport(
    $id: ID!
  ) {
    mutationResult:destroyScheduledExport (input: {
      id: $id
    }) {
      id
      errors
      scheduledExport {
        ...ScheduledExportFields
      }
    }
  }
`)
